import React, { useMemo } from "react";
import PropTypes from "prop-types";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

// const coords = {
//   lat: 50.851111,
//   lng: 4.40186442,
// };

function SectionMap(props) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyADlIORRPe1mjagjmBHREF-_rEZXLrkaYA",
  });

  // const containerStyle = {
  //   width: "100%",
  //   height: "300px",
  // };

  const center = useMemo(() => {
    const coordsArray = props.sectionContent.contentSecondary.split(";");
    return {
      lat: Number.parseFloat(coordsArray[0]),
      lng: Number.parseFloat(coordsArray[1]),
    };
  }, [props.sectionContent.contentSecondary]);
  const containerStyle = useMemo(
    () => ({ width: "100%", height: "300px" }),
    [],
  );

  const [map, setMap] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  const zoom = 16;

  return (
    <>
      <div
        className={`col-lg-${props.sectionContent.widthInColumns} col-md-${props.sectionContent.widthInColumns} xs-text-center`}
      >
        {ReactHtmlParser(props.sectionContent.content)}
      </div>
      {isLoaded ? (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
          onLoad={onLoad}
          onUnmount={onUnmount}
        >
          {/* Child components, such as markers, info windows, etc. */}
          <></>
        </GoogleMap>
      ) : (
        <></>
      )}
    </>
  );
}

SectionMap.propTypes = {
  sectioncontents: PropTypes.object,
};

export default SectionMap;
